module.exports = __webpack_public_path__ + "img/0129.6f2a13b1.png";